import { theme, colors } from './theme-preval';
export default theme;
export { colors };